export function maskNumber(text: string) {
    if (!text) return text;

    return text.replace(/\D/g, '');
}

export function maskDateBR(text: string) {
    if (!text) return text;

    let formatted = text.replace(/\D/g, '');
    if (formatted.length > 2)
        formatted = formatted.replace(/^(\d{2})(\d)/, '$1/$2');
    if (formatted.length > 5)
        formatted = formatted.replace(/^(\d{2})\/(\d{2})(\d{1,4})/, '$1/$2/$3');

    return formatted.substring(0, 10);
}

export function maskDateEN(text: string) {
    if (!text) return text;

    let formatted = text.replace(/\D/g, '');
    if (formatted.length > 4)
        formatted = formatted.replace(/^(\d{4})(\d)/, '$1-$2');
    if (formatted.length > 7)
        formatted = formatted.replace(/^(\d{4})-(\d{2})(\d{1,4})/, '$1-$2-$3');

    return formatted.substring(0, 10);
}

export function maskDate(date: string, language = "pt-br"): string {
    if (language?.toLowerCase() === "pt-br")
        return maskDateBR(date);
    else if (language?.toLowerCase() === "en-us")
        return maskDateEN(date);
    else
        return date;
}


export function maskCEP(text: string) {
    if (!text) return text;

    let formatted = text.replace(/\D/g, '');
    if (formatted.length > 2)
        formatted = formatted.replace(/^(\d{2})(\d)/, '$1.$2');
    if (formatted.length > 5)
        formatted = formatted.replace(/^(\d{2})\.(\d{3})(\d{1,3})/, '$1.$2-$3')
    return formatted.substring(0, 10);
}

export function maskPhone(text: string) {
    if (!text) return text;

    let formatted = text.replace(/\D/g, '');
    if (formatted.length > 2)
        formatted = formatted.replace(/^(\d{2})(\d)/, '($1) $2');

    if (formatted.length < 14) {
        formatted = formatted.replace(/(\d{4})(\d)/, '$1-$2');
    } else {
        formatted = formatted.replace(/(\d{5})(\d)/, '$1-$2');
    }

    return formatted.substring(0, 15);
}

export function maskCPF(text: string) {
    if (!text) return text;

    let formatted = text.replace(/\D/g, '');
    if (formatted.length > 3)
        formatted = formatted.replace(/^(\d{3})(\d)/, '$1.$2');

    if (formatted.length > 7)
        formatted = formatted.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');

    if (formatted.length > 11)
        formatted = formatted.replace(/\.(\d{3})(\d)/, '.$1-$2');

    return formatted.substring(0, 14);
}

export function maskCNPJ(text: string) {
    if (!text) return text;

    let formatted = text.replace(/\D/g, '');
    if (formatted.length > 2)
        formatted = formatted.replace(/^(\d{2})(\d)/, '$1.$2');

    if (formatted.length > 6)
        formatted = formatted.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');

    if (formatted.length > 10)
        formatted = formatted.replace(/\.(\d{3})(\d)/, '.$1/$2');

    if (formatted.length > 15)
        formatted = formatted.replace(/(\d{4})(\d)/, '$1-$2');

    return formatted.substring(0, 18);
}

export function maskCurrencyBR(value: string | number): string {
    if (value === null || value === undefined) return '';

    let formatted = value.toString().replace(/\D/g, '');

    formatted = (parseFloat(formatted) / 100).toFixed(2).replace('.', ',');

    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return formatted;
}

export function maskCurrency(value: string | number, currency: "BRL" | "USD" | "EUR" = "BRL"): string {
    if (value === null || value === undefined) return '';

    let formatted = value.toString().replace(/\D/g, '');

    if (currency === "BRL") {
        formatted = (parseFloat(formatted) / 100).toFixed(2).replace('.', ',');
        formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    if (currency === "USD" || currency === "EUR") {
        formatted = (parseFloat(formatted) / 100).toFixed(2).replace(',', '.');
        formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return formatted;
}

export function maskCurrencyToFloat(value: string | number, currency: "BRL" | "USD" | "EUR" = "BRL"): number {
    if (value === null || value === undefined) return 0;

    let formatted = value.toString();

    if (currency === "BRL") {
        formatted = formatted.replace(/\./g, '').replace('.', '').replace(',', '.');
    }

    if (currency === "USD" || currency === "EUR") {
        formatted = formatted.replace(',', '');
    }

    const parsed = parseFloat(formatted);

    return isNaN(parsed) ? 0.0 : parseFloat(parsed.toFixed(2));
}

export function maskSlug(data: string) {
    return data
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "")
        ?.replaceAll(" ", "-")
        ?.toLowerCase();
}
